import { useLocation } from 'react-router-dom';
import en from './content/en';
import es from './content/es';
import { langFromPath, PATHS } from './routes';

const CONTENT = { en, es };

export const useSite = () => {
  const { pathname } = useLocation();
  const lang = langFromPath(pathname);
  return { lang, t: CONTENT[lang], p: (key) => PATHS[key][lang] };
};
